import { useCappedList } from "@/hooks/useCappedList";
import { SearchFilterV4 } from "@/types/SearchFilter";
import { Button } from "@components/ui/button";
import PageMentionKinds from "@components/SearchFilter/partials/PageMentionKinds";
import { ButtonGroup } from "@components/ui/button-group";
import { i18n } from "@lingui/core";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@components/ui/popover";
import {
  Command,
  CommandInput,
  CommandList,
  CommandEmpty,
} from "@components/ui/command";
import { TypeIcon, XIcon } from "lucide-react";
import { Trans, useLingui } from "@lingui/react/macro";
import { MENTION_KIND_TO_LABEL } from "@/constants";

export default function MentionKinds({
  onChange,
  value,
}: {
  onChange: (value: SearchFilterV4, clear?: boolean) => void;
  value: SearchFilterV4["mention_kind"];
}) {
  const { t } = useLingui();

  // Helpers
  const formatCappedList = useCappedList();
  const isArray = Array.isArray(value);

  return (
    <ButtonGroup>
      <Button
        size="xs"
        render={<div />}
        className="pointer-events-none"
        variant="outline"
      >
        <TypeIcon />
        <Trans>Typ av omnämnande</Trans>
      </Button>
      <Button
        size="xs"
        render={<div />}
        variant="outline-muted"
        className="pointer-events-none"
      >
        {isArray && value.length > 1 ? (
          <Trans>är någon av</Trans>
        ) : (
          <Trans>är</Trans>
        )}
      </Button>
      <Popover>
        <PopoverTrigger render={<Button size="xs" variant="outline" />}>
          {value
            ? isArray
              ? formatCappedList(
                  value.map((mentionKind) =>
                    i18n._(MENTION_KIND_TO_LABEL[mentionKind])
                  ),
                  { cap: 2 }
                )
              : i18n._(MENTION_KIND_TO_LABEL[value])
            : "N/A"}
        </PopoverTrigger>
        <PopoverContent align="start" className="w-80 p-0">
          <Command>
            <CommandInput placeholder={t`Typ av omnämnande`} />
            <CommandList>
              <CommandEmpty>
                <Trans>Inga filter hittades</Trans>
              </CommandEmpty>
              <PageMentionKinds value={value} onChange={onChange} />
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
      <Button
        size="icon-xs"
        variant="outline"
        type="button"
        onClick={() => {
          onChange({
            mention_kind: undefined,
          });
        }}
      >
        <XIcon />
        <span className="sr-only">
          <Trans>Ta bort filter</Trans>
        </span>
      </Button>
    </ButtonGroup>
  );
}
